import React from 'react';
import ReactPlayer from 'react-player/youtube';

const Beretta = () => (
  <ReactPlayer url="https://youtu.be/xjAxAdErowg" width="100%" height="100%" />
);

export default Beretta;
